import { RouterProvider } from "react-router-dom"
import { router } from "./routes/index.jsx";
import { AuthProvider } from "./context-state/AuthContext.jsx";
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from "@vercel/speed-insights/react";
import { APP_ENV, GOOGLE_AUTH_CLIENT_ID, PUBLIC_POSTHOG_HOST, PUBLIC_POSTHOG_KEY } from "@/config-global.jsx";
import { Toaster } from '@/components/ui/sonner.jsx'
import { useNewVersionPolling } from '@/hooks/useNewVersionPolling.jsx'
import { NewVersionMessage } from '@/components/new-version/NewVersionMessage.jsx'
import { PostHogProvider } from 'posthog-js/react'
import posthog from 'posthog-js'
import { useEffect } from "react"
import { AnalyticsService } from "@/services/analytics.js";
import { GoogleOAuthProvider } from "@react-oauth/google";


function App() {

    const newVersionAvailable = useNewVersionPolling()
    const posthogOptions = {
        api_host: PUBLIC_POSTHOG_HOST,
        defaults: '2025-05-24',
        cross_subdomain_cookie: true,
        persistence: 'cookie',
    }

    useEffect(() => {
        posthog.register({ surface: 'app' })

        AnalyticsService.track('app-loaded', {
            path: window.location?.pathname,
            search: window.location?.search,
            href: window.location?.href,
            referrer: window.location?.referrer,
        })
    }, [])

    return (
        <GoogleOAuthProvider clientId={GOOGLE_AUTH_CLIENT_ID}>
            <PostHogProvider apiKey={PUBLIC_POSTHOG_KEY} options={posthogOptions}>
                <div className="app h-screen w-full font-geist">
                    <AuthProvider>
                        {
                            APP_ENV !== 'local' ? <><Analytics /><SpeedInsights /></> : null
                        }
                        <RouterProvider router={router} />
                        <Toaster />
                    </AuthProvider>
                    {
                        newVersionAvailable ? <NewVersionMessage /> : null
                    }
                </div>
            </PostHogProvider>
        </GoogleOAuthProvider>

    )
}

export default App
